import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/login/login";
import DashboardLayout from "./pages/dashboard/dashboardLayout";
import PrivateRoutes from "./routes_private";
import NotFound404 from "./pages/404/404";
import VotingList from "./pages/mainContent/voting/votingList";
import MusicianList from "./pages/mainContent/musician/musicianList";
import CreateMusician from "./pages/mainContent/musician/createMusician";
import VotingFilter from "./pages/mainContent/musician/votingFilter";
import Dashboard from "./pages/dashboard/dashboard";
import AdminAmountReportsByDelegationCompany from "./pages/reports/AdminAmountReportsByDelegationCompany";
import VotingQuery from "./pages/reports/VotingQuery";
import DailyVotingList from "./pages/reports/DailyVotingList";
import NewDashboardLayout from "./pages/dashboard/newDashboardLayout";
import MobileDashboardLayout from "./pages/dashboard/mobileDashboardLayout.jsx";
import PersonalizedSearch from "./pages/mainContent/personalized/personalized_search.jsx";
import { EditionProvider } from "./components/context/EditionContext.js";
import AdminDelegacoes from "./pages/admin/delegacoes/AdminDelegacoes";
import AdminGerirEdicoes from "./pages/admin/edicoes/AdminGerirEdicoes";
import AdminDisponibilidade from "./pages/admin/disponibilidade/AdminDisponibilidade";
import AdminMusicianByEdition from "./pages/admin/musician/AdminMusicianByEdition";
import CompanyEdicoes from "./pages/company/edicoes/CompanyEdicoes";
import AdminUsuarios from "./pages/admin/usuarios/AdminUsuarios";

const AppRouter = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);

    return () => {
      window.removeEventListener("resize", checkDevice);
    };
  }, []);

  const Layout = isMobile ? MobileDashboardLayout : NewDashboardLayout;

  return (
    <Router>
      <div className="container">
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route
              path="/dashboard"
              element={
                <EditionProvider>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/voting/all"
              element={
                <EditionProvider>
                  <Layout>
                    <VotingList />
                  </Layout>
                </EditionProvider>
              }
            />

            <Route
              path="/voting/search/personalised"
              element={
                <EditionProvider>
                  <Layout>
                    <PersonalizedSearch />
                  </Layout>
                </EditionProvider>
              }
            />

            <Route
              path="/voting/category"
              element={
                <EditionProvider>
                  <Layout>
                    <VotingFilter />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              element={
                <NotFound404 />
              }
              path="*"
            />
            <Route
              path="/admin/musician/all"
              element={
                <EditionProvider>
                  <Layout>
                    <MusicianList />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/musician/all"
              element={
                <EditionProvider>
                  <Layout>
                    <MusicianList />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/admin/musician/create"
              element={
                <EditionProvider>
                  <Layout>
                    <CreateMusician />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/admin/finance/reports"
              element={
                <EditionProvider>
                  <Layout>
                    <AdminAmountReportsByDelegationCompany />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/admin/finance/query/votings"
              element={
                <EditionProvider>
                  <Layout>
                    <VotingQuery />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/admin/delegacoes"
              element={
                <EditionProvider>
                  <Layout>
                    <AdminDelegacoes />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/admin/edicoes"
              element={
                <EditionProvider>
                  <Layout>
                    <AdminGerirEdicoes />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/admin/disponibilidade"
              element={
                <EditionProvider>
                  <Layout>
                    <AdminDisponibilidade />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/admin/musicians-by-edition"
              element={
                <EditionProvider>
                  <Layout>
                    <AdminMusicianByEdition />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/admin/usuarios"
              element={
                <EditionProvider>
                  <Layout>
                    <AdminUsuarios />
                  </Layout>
                </EditionProvider>
              }
            />
            <Route
              path="/company/edicoes"
              element={
                <EditionProvider>
                  <Layout>
                    <CompanyEdicoes />
                  </Layout>
                </EditionProvider>
              }
            />
          </Route>
          <Route path="/" element={<Login />} exact />
        </Routes>
      </div>
    </Router>
  );
};

export default AppRouter;
